<!--
 * @Description  : 审核列表页
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:07:38
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-06-22 10:31:27
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\audit-affairs-new\index.vue
-->

<template>
	<div class="h100 audit">
		<!-- 列表查询页 -->
		<filter-layout @search="searchName" @reset="reset" v-if="!routeQuery" hasMore hasHeader>
			<template #header>
				<el-tabs v-model="auditState1" @tab-click="tabChange(auditState1)">
					<el-tab-pane name="0">
						<span slot="label"
							>待审核
							<el-badge :value="tabNumber2" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="1">
						<span slot="label"
							>审核通过
							<el-badge :value="tabNumber3" class="item"></el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="2">
						<span slot="label"
							>审核驳回
							<el-badge :value="tabNumber4" class="item"> </el-badge>
						</span>
					</el-tab-pane>
					<el-tab-pane name="4">
						<span slot="label"
							>全部
							<el-badge :value="tabNumber1" class="item"></el-badge>
						</span>
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="主体名称">
						<el-input v-model="searchForm.applySub" placeholder="请输入主体名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="申请人">
						<el-input v-model="searchForm.applyUser" placeholder="请输入申请人名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="申请时间">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="主体类型">
						<el-select v-model="searchForm.objectType" placeholder="请选择" clearable>
							<el-option :value="1" label="企业申请"></el-option>
							<el-option :value="0" label="个人申请"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef2" :model="searchForm" label-width="110px">
					<el-form-item label="待办理事项">
						<el-select v-model="searchForm.busType" placeholder="请选择审核事项" clearable>
							<el-option v-for="item in projectDict.ywlx" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="w-table-layout w-table-page pdt10">
					<div class="w-table-content" v-show="tableShow">
						<el-table :data="filiterData" height="100%" highlight-current-row row-key="id" border ref="table">
							<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
							<el-table-column
								prop="typeName"
								label="待办理事项"
								header-align="center"
								min-width="200"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="type" label="主体类型" align="center" width="140" show-overflow-tooltip>
								<template slot-scope="scope">
									<span v-if="scope.row.objectType == 0">个人</span>
									<span v-else>企业</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="applySub"
								label="主体名称"
								header-align="center"
								min-width="200"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="createUser" label="申请人" align="center" width="140" show-overflow-tooltip></el-table-column>
							<el-table-column
								prop="createDate"
								label="申请时间"
								width="160"
								align="center"
								sortable
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								v-if="auditState1 != 0"
								prop="updateUser"
								label="审核人"
								align="center"
								width="140"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								v-if="auditState1 != 0"
								prop="updateDate"
								label="审核时间"
								width="160"
								align="center"
								sortable
								show-overflow-tooltip
							>
								<template slot-scope="scope">
									<span v-if="scope.row.auditType">
										{{ scope.row.createDate }}
									</span>
									<span v-else>{{ scope.row.updateDate }}</span>
								</template>
							</el-table-column>
							<el-table-column header-align="center" align="center" prop="auditType" label="审核类型" show-overflow-tooltip>
								<template slot-scope="scope">
									<span>{{ scope.row.auditType ? '系统自动审核' : '人工审核' }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="status" label="状态" sortable width="150" align="center" :resizable="false" show-overflow-tooltip>
								<template slot-scope="scope">
									<template v-if="scope.row.status == 0">
										<span class="orange">
											{{ scope.row.busType == 1002049004 ? '系统处理中' : '待审核' }}
										</span>
									</template>
									<span class="green" v-else-if="scope.row.status == 1">审核通过</span>
									<span class="red" v-else-if="scope.row.status == 2">审核驳回</span>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot="header">操作</template>
								<template slot-scope="scope">
									<el-button
										v-if="scope.row.status == 0 && scope.row.busType != 1002049004 && roleBtns.includes('audit')"
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										@click="audit(scope.row)"
									>
										<svg-icon icon-class="form-examine"></svg-icon> 审核
									</el-button>
									<el-button
										v-else-if="roleBtns.includes('audit-view')"
										type="primary"
										size="small"
										round
										plain
										class="table-btn"
										@click="audit(scope.row, 'view')"
									>
										<svg-icon icon-class="form-look"></svg-icon> 查看
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer" v-if="!routeQuery">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<div v-else class="h100 audit operation-layout" :class="{ sHeight: routeQuery == 'check' || routeQuery == 'checkZj' }">
			<div class="operation-main">
				<!-- 查看、审核 安招采-->
				<audit-msg
					v-if="routeQuery == 'check'"
					ref="childContent"
					:isDisabled="this.$route.query.mode"
					:companyId="companyId"
					@openDia="openDia"
					:rowData="rowData"
				></audit-msg>

				<!-- 查看、审核 专家 -->
				<audit-msg-zj v-if="routeQuery == 'checkZj'" @openDia="openDia" :rowData="rowData"></audit-msg-zj>

				<!-- 查看、审核 CA-->
				<audit-ca v-if="routeQuery == 'checkCa'" :tenantId="tenantId" :creditCode="creditCode"></audit-ca>

				<!-- 查看、审核 电子发票 -->
				<audit-invoice v-if="routeQuery == 'check-invoice'" :rowData="rowData"></audit-invoice>
				<!-- 查看、审核询匠通服务商认证  -->
				<service-provider
					v-if="routeQuery == 'check-provider'"
					:companyId="companyId"
					:rowData="rowData"
					@openDia="openDia"
				></service-provider>
				<!-- 查看各项业务  -->
				<recruitment-business
					v-if="routeQuery == 'check-recruit'"
					:companyId="companyId"
					:typeId="typeId"
					:rowData="rowData"
					@openDia="openDia"
				></recruitment-business>
				<!-- 查看、审核出租方入驻申请 -->
				<lease-rent v-if="routeQuery == 'check-lease'" :companyId="companyId" :rowData="rowData" @openDia="openDia"></lease-rent>
				<!-- 查看、审核劳务通-劳务认证 -->
				<labour-service v-if="routeQuery == 'check-labour'" :companyId="companyId" :rowData="rowData" @openDia="openDia"></labour-service>
			</div>
		</div>

		<!-- 审核弹框 -->
		<el-dialog :visible.sync="auditShow" width="600px" center title="审核" :close-on-click-modal="false" @close="closeDialog">
			<el-form label-width="120px" :model="checkForm" ref="checkRef" :rules="checkRule">
				<el-form-item label="审核结果" prop="status">
					<el-select v-model="checkForm.status">
						<el-option label="审核通过" value="1"></el-option>
						<el-option label="驳回" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="审核意见" prop="remark">
					<el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="checkForm.remark" maxlength="150" show-word-limit>
					</el-input>
				</el-form-item>
			</el-form>
			<div style="text-align: center">
				<el-button class="btn cancel-btn" size="small" @click="closeDialog">取消</el-button>
				<el-button class="btn btn-blue" type="primary" size="small" @click="submitCheck">提交</el-button>
			</div>
		</el-dialog>

		<!-- 查看CA -->
		<el-dialog :close-on-click-modal="false" center class="view-ca-dia hidden" title="查看" :visible.sync="caVisible" width="800px">
			<div>
				<div class="mb30 mt20 text-center">
					<img src="@/assets/images/pass.png" class="mb30" alt="" />
					<p class="fontWeightBold">已成功申请企业CA数字证书！</p>
				</div>
				<div class="pdl10 pdr10">
					<el-tabs v-model="activeName">
						<el-tab-pane
							v-for="(item, index) in certificateList"
							:key="'certificate' + index"
							:label="'#' + (index + 1) + ' 证书'"
							:name="index + ''"
						>
							<el-row class="mt20">
								<el-col :span="16" class="left">-</el-col>
								<el-col :span="8" class="right">
									<span>证书所有者</span>
								</el-col>
							</el-row>
							<el-row class="mt20">
								<el-col :span="16" class="left">-</el-col>
								<el-col :span="8" class="right">
									<span>证件号</span>
								</el-col>
							</el-row>
							<el-row class="mt20">
								<el-col :span="16" class="left">-</el-col>
								<el-col :span="8" class="right">
									<span>证书序列号</span>
								</el-col>
							</el-row>
							<el-row class="mt20">
								<el-col :span="16" class="left">-</el-col>
								<el-col :span="8" class="right">
									<span>证书有效期</span>
								</el-col>
							</el-row>
							<el-row class="mt20">
								<el-col :span="16" class="left">-</el-col>
								<el-col :span="8" class="right">
									<span>介质类型 (key 华申3.0)</span>
								</el-col>
							</el-row>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</el-dialog>

		<!-- 审核企业申请 -->
		<el-dialog
			:title="companyDialog.title"
			:visible.sync="companyDialog.show"
			width="1000px"
			:close-on-click-modal="false"
			center
			append-to-body
			class="audit-company-dialog"
			@close="qyClose"
			top="4vh"
		>
			<!-- 创建企业 新 -->
			<audit-identify
				ref="auditIdentify"
				v-if="companyDialog.show && companyDialog.mode == 'add' && rowData.isOld != 1"
				@close="closeCompanyDia"
				@btnClose="companyLoading = false"
				:rowData="rowData"
				:mode="mode"
				showCompany
			></audit-identify>
			<!-- 变更企业 新 -->
			<audit-changeCompany
				v-if="companyDialog.show && companyDialog.mode == 'edit' && rowData.isOld != 1"
				ref="qyDialog"
				:viewId="tenantId"
				:companyId="companyId"
				:rowData="rowData"
				@closeCompanyDia="closeCompanyDia"
				:mode="mode"
				:audit="addOrEdit"
			></audit-changeCompany>
			<!-- 创建企业旧 + 变更企业旧 -->
			<qyDialog
				v-if="companyDialog.show && rowData.isOld == 1"
				ref="qyDialog"
				:viewId="tenantId"
				:companyId="companyId"
				:rowData="rowData"
				@closeCompanyDia="closeCompanyDia"
				:mode="mode"
				:audit="addOrEdit"
			></qyDialog>
			<div slot="footer" v-if="mode != 'view'">
				<el-button class="btn" @click="companyDialog.show = false">取 消</el-button>
				<el-button class="btn btn-blue" type="primary" :loading="companyLoading" @click="doCheckCompany">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 专家信息变更操作审核弹窗 -->
		<el-dialog title="专家认证信息变更审核" :visible.sync="zjCheckObj.show" width="1000px" :close-on-click-modal="false" top="5vh" center>
			<InformationChangeReview v-if="zjCheckObj.show" :rowData="rowData" @closeZjCheck="closeZjCheck"> </InformationChangeReview>
		</el-dialog>

		<!-- 个人实名认证 -->
		<el-dialog
			title="实名认证-审核"
			:visible.sync="realObj.show"
			width="1000px"
			top="4vh"
			:close-on-click-modal="false"
			@closed="realClose"
			center
		>
			<audit-identify
				ref="auditIdentify"
				v-if="realObj.show && rowData.isOld == 0"
				@close="closeRealDia"
				@btnClose="realClose"
				:rowData="rowData"
				:mode="mode"
			></audit-identify>
			<real-name
				ref="realname"
				v-if="realObj.show && rowData.isOld == 1"
				@closeReal="closeRealDia"
				@btnClose="realClose"
				:rowData="rowData"
				:mode="mode"
			></real-name>
			<div slot="footer" v-if="mode != 'view'">
				<el-button class="btn" @click="realObj.show = false">取 消</el-button>
				<el-button class="btn btn-blue" type="primary" :loading="realNameLoading" @click="doCheckRealName">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 个人实名认证（微信小程序） -->
		<el-dialog title="实名认证-审核" :visible.sync="appRealObj.show" width="1000px" top="4vh" :close-on-click-modal="false" center>
			<app-real ref="realname" v-if="appRealObj.show" :rowData="rowData"></app-real>
		</el-dialog>

		<!-- 企业申诉 -->
		<AppealDialogOld v-if="appealShow && rowData.isOld == 1" ref="appealDialog" :mode="mode" :rowData="rowData" @closeAppeal="closeAppeal">
		</AppealDialogOld>
		<AppealDialog v-if="appealShow && rowData.isOld !== 1" ref="appealDialog" :mode="mode" :rowData="rowData" @closeAppeal="closeAppeal">
		</AppealDialog>

		<!-- 企业提现账户弹窗 -->
		<el-dialog :visible.sync="accountDialog.visible" :title="accountDialog.title" width="1000px" top="5vh">
			<audit-Account
				:rowId="companyId"
				v-if="accountDialog.visible"
				ref="accountDialog"
				:infoObj="rowData"
				:mode="accountDialog.mode"
			></audit-Account>

			<!-- 底部按钮 -->
			<div slot="footer" class="text-center" v-if="accountDialog.mode !== 'view'">
				<el-button class="btn" @click="accountDialog.visible = false">取 消</el-button>
				<el-button class="btn btn-blue" type="primary" :loading="accountDialog.btnLoading" @click="doAuditAccount">确 定</el-button>
			</div>
		</el-dialog>

		<!--安招采-协会专家库承诺书 审核  -->
		<expert-dialog ref="expert_dialog" v-if="showExpertDialog"></expert-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getListNew } from 'api/modules/audit'
import { auditSubmit } from '@/api/modules/invoice'
import auditMsg from './components/audit'
import auditMsgZj from './components/audit-zj'
import auditCa from './components/audit-ca'
import serviceProvider from './components/service-provider'
import auditInvoice from './components/audit-invoice'
import auditAccount from './components/audit-account'
import RecruitmentBusiness from './components/recruitment-business'
import LeaseRent from './components/lease-rent'
import LabourService from './components/labour-service'
import realName from '@/views/operation-management/audit-affairs-new/components/real-name'
import appReal from '@/views/operation-management/audit-affairs-new/components/app-real'
import qyDialog from '@/views/operation-management/audit-affairs-new/components/qy-dialog'
import auditChangeCompany from '@/views/operation-management/audit-affairs-new/components/audit-changeCompany'
import InformationChangeReview from '@/views/operation-management/audit-affairs-new/components/InformationChangeReview'
import AppealDialogOld from '@/views/operation-management/audit-affairs-new/components/appeal-dialog'
import AppealDialog from './components/audit-appeal.vue'
import ExpertDialog from './components/expert-dialog.vue'

// 新版 身份认证
const auditIdentify = () => import('./components/audit-identify.vue')
export default {
	name: 'audit-affairs-new',
	components: {
		auditMsg,
		auditMsgZj,
		auditCa,
		auditInvoice,
		auditAccount,
		qyDialog,
		InformationChangeReview,
		realName,
		appReal,
		AppealDialogOld,
		AppealDialog,
		serviceProvider,
		RecruitmentBusiness,
		LeaseRent,
		LabourService,
		ExpertDialog,
		auditIdentify,
		auditChangeCompany
	},
	data() {
		return {
			auditState1: '0',
			//标签红点
			tabNumber1: 0,
			tabNumber2: 0,
			tabNumber3: 0,
			tabNumber4: 0,
			filiterData: [],
			loading: false,
			//筛选框
			searchForm: {
				applySub: '', //主体名称
				applyUser: '', //申请人
				dateArr: [],
				startDate: '', //申请开始时间
				endDate: '', //申请结束时间
				objectType: '', //主体类型
				busType: '' //审核事项
			},
			auditState: '0',
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			auditShow: false, // 审核弹窗的显隐
			companyId: '', //当前行数据的id
			tenantId: '', //公司tenantId
			checkForm: {
				status: '', //审核结果
				updateUserid: '', //当前用户id
				id: '', //审核项id
				libId: '1336844778641297410', //专家库id
				remark: '' //审核意见
			},
			checkRule: {
				status: [{ required: true, message: '审核结果不能为空' }],
				remark: [{ required: true, message: '审核意见不能为空' }],
				libId: [{ required: true, message: '专家库不能为空' }]
			},
			dataType: '',
			zjObj: {}, // 用于接收专家审核传过来的参数
			rowData: {}, // 表格操作当前行数据
			typeId: '', //业务申请开通类型id
			startDatePicker: this.beginDate(), //限制选择时间的开始
			endDatePicker: this.processDate(), //限制选择时间的结束
			caVisible: false, //控制ca查看弹窗显隐
			certificateList: [
				{
					id: ''
				}
			], //证书列表
			activeName: '0', //证书列表可能多个，默认第一个
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			creditCode: '', //社会统一信用码
			// 审核、查看企业弹窗
			companyDialog: {
				show: false,
				mode: 'add',
				title: ''
			},
			companyLoading: false, //企业弹窗 按钮loading
			mode: '', //企业弹窗 操作类别(审核、查看)
			// 专家信息变更弹窗
			zjCheckObj: {
				show: false
			},
			// 实名认证审核
			realObj: {
				show: false
			},
			// 实名认证审核（微信小程序）
			appRealObj: {
				show: false
			},
			addOrEdit: '',
			appealShow: false,
			realNameLoading: false,
			// 企业提现账户弹窗
			accountDialog: {
				visible: false,
				title: '审核-对公提现账户信息变更',
				mode: 'audit',
				btnLoading: false
			},

			showExpertDialog: false // 协会专家库承诺书弹窗显隐
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('activeTab')) {
				this.auditState1 = JSON.parse(this.$getSessionItem('activeTab'))
				// 移除 避免污染
				this.$removeSessionItem('activeTab')
			}

			if (this.$getSessionItem('params')) {
				this.searchForm = JSON.parse(this.$getSessionItem('params'))
				this.currentPage = JSON.parse(this.$getSessionItem('params')).current
				this.pageSize = JSON.parse(this.$getSessionItem('params')).size
				this.auditState = JSON.parse(this.$getSessionItem('params')).status

				// 移除 避免污染
				this.$removeSessionItem('params')
			}
		}
		this.getData()
	},
	methods: {
		// 关闭loading
		realClose() {
			this.realNameLoading = false
		},

		// 实名认证审核
		doCheckRealName() {
			this.realNameLoading = true
			this.$refs.auditIdentify.doSubmit()
		},

		// 审核提交
		doCheckCompany() {
			this.companyLoading = true
			if (this.companyDialog.mode == 'edit') {
				this.$refs.qyDialog.checkCompany()
			} else {
				this.$refs.auditIdentify.doSubmit()
			}
		},

		// 审核企业弹窗关闭
		closeCompanyDia(data, id) {
			this.companyLoading = false
			if (data == '1' || data == 'all') {
				this.companyDialog.show = false
				this.getData()
			}
		},

		// tab切换
		tabChange(val) {
			this.currentPage = 1
			this.pageSize = 10
			if (val == 4) {
				this.auditState = ''
			} else {
				this.auditState = val
			}
			this.getData()
		},

		// 搜索
		searchName() {
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		//获得列表数据
		getData(isBack) {
			if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
				this.searchForm.startDate = this.searchForm.dateArr[0] + ' 00:00:00'
				this.searchForm.endDate = this.searchForm.dateArr[1] + ' 23:59:59'
			} else {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
			}
			let params = Object.assign({}, this.searchForm)

			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.status = this.auditState

			getListNew(params)
				.then((res) => {
					this.loading = false
					this.filiterData = res.data.pageList.records
					this.currentPage = parseInt(res.data.pageList.current)
					this.total = parseInt(res.data.pageList.total)
					this.pageSize = parseInt(res.data.pageList.size)
					this.tabNumber1 = res.data.allRecordsCount
					this.tabNumber2 = res.data.backlogRecordsCount
					this.tabNumber3 = res.data.passRecordsCount
					this.tabNumber4 = res.data.rejectRecordsCount
					// 设置回显
					this.setChecked()
				})
				.catch((err) => {
					this.loading = false
				})
		},

		//筛选框重置
		reset() {
			this.searchForm.applySub = ''
			this.searchForm.applyUser = ''
			this.searchForm.dateArr = []
			this.searchForm.startDate = ''
			this.searchForm.endDate = ''
			this.searchForm.objectType = ''
			this.searchForm.busType = ''
			this.pageSize = 10
			this.currentPage = 1
			this.getData()
		},

		// 点击审核
		audit(data, type) {
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			params.status = this.auditState
			// 存值
			this.$setSessionItem('params', JSON.stringify(params))
			this.$setSessionItem('activeTab', JSON.stringify(this.auditState1))
			// tenantId
			this.rowData = data
			this.companyId = data.id
			this.tenantId = data.busId
			this.dataType = data.type
			this.creditCode = data.creditCode
			this.sysNo = data.sysNo
			switch (data.busType) {
				case '1002049003':
					// 普通审核
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check',
							mode: type
						}
					})
					break
				case '1002049001':
					// 专家审核
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'checkZj',
							mode: type,
							isBase: true
						}
					})
					break
				case '1002049022':
					// 加入专家库审核、查看
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'checkZj',
							mode: type,
							isBase: false
						}
					})
					break
				case '1002049004':
					// CA 审核
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'checkCa',
							mode: type,
							id: data.id
						}
					})
					break
				case '1002049005':
					// 开票审核
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check-invoice',
							mode: type,
							id: data.id,
							companyName: encodeURI(data.applySub)
						}
					})
					break
				case '1002049006':
					//创建企业
					this.addOrEdit = data.busType
					this.mode = type
					this.companyDialog.show = true
					this.companyDialog.mode = 'add'

					type == 'view' ? (this.companyDialog.title = '查看企业信息') : (this.companyDialog.title = '审核企业信息')
					break
				case '1002049007':
					// 修改企业
					this.addOrEdit = data.busType
					this.mode = type
					this.companyDialog.show = true
					this.companyDialog.mode = 'edit'
					type == 'view' ? (this.companyDialog.title = '查看企业信息') : (this.companyDialog.title = '审核企业信息')
					break
				case '1002049002':
					// 专家信息变更
					this.zjCheckObj.show = true
					break
				case '1002049008':
					if (this.sysNo == '1001028008') {
						// 个人实名认证(PC端)
						this.mode = type
						this.realObj.show = true
					} else {
						// 个人实名认证(微信小程序)
						this.appRealObj.show = true
					}
					break
				case '1002049009':
					//企业申诉
					this.mode = type
					this.appealShow = true
					setTimeout(() => {
						data.isOld == 1 ? (this.$refs.appealDialog.dialogShow = true) : this.$refs.appealDialog.openDialog()
					}, 200)
					break
				case '1002049011':
					// 变更企业账户
					this.accountDialog.visible = true
					this.accountDialog.title = '审核-对公提现账户信息变更'
					this.accountDialog.mode = type === 'view' ? 'view' : 'audit'
					break
				case '1002049012':
					//询匠通服务商认证 serviceProvider
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check-provider',
							mode: type
						}
					})
					break
				case '1002049015':
					//出租方入驻申请
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check-lease',
							mode: type
						}
					})
					break
				case '1002049018':
					//劳务通-劳务认证
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check-labour',
							mode: type
						}
					})
					break

				case '1002049026':
					// 安招采-协会专家库承诺书
					this.showExpertDialog = true
					setTimeout(() => {
						this.$refs.expert_dialog.dialogOpen(data.id)
					}, 200)
					break
				default:
					//询匠通招募业务
					this.typeId = data.busType
					this.$router.push({
						name: 'Audit-affairs-new',
						query: {
							type: 'check-recruit',
							mode: type
						}
					})
					break
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},

		// 审查提交
		submitCheck() {
			this.$refs.checkRef.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.zjObj)
					params.status = this.checkForm.status
					params.remark = this.checkForm.remark
					params.busType = this.rowData.busType
					auditSubmit(params).then((d) => {
						if (d.code == 0) {
							this.checkForm.status == 1 ? this.$message.success('审核成功') : this.$message.success('已驳回')
							this.$router.push({ path: '/audit-affairs-new' })
							this.auditShow = false
							this.getData()
							this.$refs.checkRef.resetFields()
						}
					})
				} else {
					this.$message.warning('请校验表单')
				}
			})
		},

		// open 审查弹框
		openDia(data) {
			this.auditShow = true
			this.zjObj = data
		},

		// close 审查弹框
		closeDialog() {
			this.auditShow = false
			this.$refs.checkRef.resetFields()
			this.checkForm.remark = ''
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = that.searchForm.endDate
					if (endTime) {
						return bmElementTimeOptins.limitDateBefore(time, endTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = that.searchForm.startDate
					if (startTime) {
						let nowTime = Date.now()
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, true)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 专家审核
		closeZjCheck(data) {
			this.zjCheckObj.show = false
			if (data) {
				this.getData()
			}
		},

		// 个人实名认证关闭
		closeRealDia(data) {
			this.realObj.show = false
			if (data == '1') {
				this.getData()
			}
		},

		// 企业弹窗关闭
		qyClose() {
			this.addOrEdit = ''
		},

		// 申诉企业关闭时接收
		closeAppeal(data) {
			this.appealShow = data
			this.getData()
		},

		// 确定审核 提现账户
		async doAuditAccount() {
			this.accountDialog.btnLoading = true
			let result = await this.$refs.accountDialog.onSubmit()
			// console.log(result)

			if (result) {
				let params = this.$refs.accountDialog.auditForm
				params.id = this.companyId
				params.busId = this.tenantId
				params.busType = this.rowData.busType
				auditSubmit(params)
					.then((res) => {
						this.$message.success('审核完成')
						setTimeout(() => {
							this.accountDialog.visible = false
							this.accountDialog.btnLoading = false

							this.getData()
						}, 1000)
					})
					.catch((err) => {
						setTimeout(() => {
							this.accountDialog.btnLoading = false
						}, 1000)
					})
			} else {
				setTimeout(() => {
					this.accountDialog.btnLoading = false
				}, 1000)
			}
		}
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		...mapState('user', { userInfo: (state) => state.userInfo }),

		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),

		routeQuery() {
			return this.$route.query.type
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		},

		// 监听路由参数 --- 回到主界面时刷新查询
		$route(params) {
			let arr = Object.keys(params.query)
			if (arr.length === 0) {
				this.getData()
			}
		}
	}
}
</script>

<style scoped lang="less">
.audit {
	.searchBox {
		padding-top: 8px;
	}

	/deep/ .more-layout {
		top: 55px;
		right: 370px;
	}

	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;

		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}

	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}

	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}

	.auditMsg {
		color: #2671cc;
		cursor: pointer;
	}

	.green,
	.red,
	.orange {
		display: inline-block;
		height: 28px;
		line-height: 28px;
		padding: 0 10px;
		font-size: 12px;
		border-radius: 5px;
	}

	.green {
		background: #e9f6f2;
		border: 1px solid #bff5e5;
		color: #39c098;
	}

	.red {
		background: #feeff0;
		border: 1px solid #fde2e2;
		color: #f56c6c;
	}

	.orange {
		background: #fdf6ec;
		border: 1px solid #faecd8;
		color: #e7a23c;
	}

	.toolbar {
		position: relative;

		.toolbar-right {
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}

	.item {
		position: absolute !important;
		right: -15px;
	}
}

.sHeight {
	padding: 0;
}

.view-ca-dia {
	/deep/ .el-dialog__header {
		background-color: #2671cc;

		span,
		.el-dialog__close {
			color: #fff;
			font-weight: normal;
		}
	}

	.fontWeightBold {
		color: #202020;
		font-size: 16px;
	}

	.left {
		color: #202020;
		font-weight: 600;
	}

	.right {
		color: #666666;
		text-align: right;
	}
}

.audit-company-dialog {
	/deep/ .el-dialog__body {
		max-height: 700px !important;
	}
}

@media screen and (max-height: 900px) {
	/deep/ .el-dialog__body {
		max-height: 560px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 560px !important;
		}
	}
}

@media screen and (max-height: 660px) {
	/deep/ .el-dialog__body {
		max-height: 440px !important;
	}

	.audit-company-dialog {
		/deep/ .el-dialog__body {
			max-height: 440px !important;
		}
	}
}
</style>
